$(document).ready(function () {
  const $slider = $('.block__new-casestudy-slider');
  if (!$slider.length) return;

  $slider.each(function () {
    const $el = $(this);
    const isHighlightSlider = $el.hasClass('block__highlight-casestudy-slider');
    const $highlightWrapper = $el.closest('.block__highlight-casestudy-slider-wrapper');
    const $highlightArrows = $el
      .closest('.block__highlight-casestudy-slider-wrapper')
      .find('.block__highlight-casestudy-slider-arrows');

    const updateHighlightArrowPosition = function () {
      if (!isHighlightSlider || !$highlightWrapper.length) return;

      if (window.innerWidth > 1024) {
        $highlightWrapper[0].style.removeProperty('--highlight-arrow-top');
        return;
      }

      const $currentContent = $el
        .find('.slick-current.slick-active .block__highlight-casestudy-content, .slick-current .block__highlight-casestudy-content')
        .first();
      if (!$currentContent.length) return;

      const wrapperTop = $highlightWrapper.offset().top;
      const contentTop = $currentContent.offset().top - wrapperTop;
      const contentCenter = contentTop + ($currentContent.outerHeight() / 2);

      $highlightWrapper[0].style.setProperty('--highlight-arrow-top', `${contentCenter}px`);
    };

    const scheduleHighlightArrowPosition = function () {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(updateHighlightArrowPosition);
      });
    };

    const slickOptions = {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: isHighlightSlider ? !!$highlightArrows.length : true,
      adaptiveHeight: !isHighlightSlider,
      centerMode: true,
      centerPadding: isHighlightSlider ? '70px' : '8.1%'
    };

    if (!isHighlightSlider) {
      slickOptions.prevArrow = $el
        .siblings('.block__new-casestudy-slider-arrows')
        .find('.block__new-casestudy-slider-arrow-prev');
      slickOptions.nextArrow = $el
        .siblings('.block__new-casestudy-slider-arrows')
        .find('.block__new-casestudy-slider-arrow-next');
    } else {
      $el.on('init reInit afterChange setPosition breakpoint', scheduleHighlightArrowPosition);
      $(window).on('resize', scheduleHighlightArrowPosition);
      slickOptions.prevArrow = $highlightArrows.find('.arrow_prev');
      slickOptions.nextArrow = $highlightArrows.find('.arrow_next');
      slickOptions.variableWidth = true;
      slickOptions.responsive = [
        {
          breakpoint: 1025,
          settings: {
            variableWidth: false,
            centerMode: true,
            centerPadding: '35px'
          }
        },
        {
          breakpoint: 768,
          settings: {
            variableWidth: false,
            centerMode: true,
            centerPadding: '24px'
          }
        }
      ];
    }

    $el.slick(slickOptions);
    scheduleHighlightArrowPosition();
  });
});